import ZProps from './zprops';
import ZUtil from './zutil';
import ZLog from './zlog';
import AMC from './AMC';
//import { WModel } from './hack';

/*
	TODO A new way to do this.
	save copy of model
	caller says "I just modded the model, call this mod: "add visualization"
	then we check diffs [with shadow model] and bundle them up and save as a combined sequence of ops as one undoable command
	and save it and new model to DB.

*/
// UndoableGraph
// pass in graphs during txn and collect them for save
var AMCTransactionsManagerFactory = {
	manageds: {},

	manage(component, graphapi) {
		return this.manageds[component.uri] || new AMCTransactionsManager(component, graphapi);
	},
	unmanage(manager) {
		if (manager) {
			delete this.manageds[manager.getManaged().uri];
			manager.termin();
		}
	}
}
		
// TODO this -> var and return API public methods only which is of form API.termin = ... but not _publish private methods
// TODO make graph editor use this too
export function AMCTransactionsManager(component, graphapi) {
	this.nextid = 1;
	this.undostack = [];
	this.undo_index = 0;
	this.txn = null;
	this.saver = function(uri) { ZUtil.throttle(uri, function() { AMC.save(uri, (err) => {} ) }, 1000) };
	this.subscribers = {};
	this.component = component;
	this.uri = component.uri;
	this.graphapi = graphapi;
	this.undostack = component.ops || []; 
// this.undostack = []; // TESTT if want to zero out undo stack each load
	this.undo_index = this.undostack.length; 

	this.termin = function() {
		this.subscribers = {};
	}
	this.setSaver = function(f) {
		ZLog.debug("set saver for " + this.uri, { f: f});
		this.saver = f;
	}
	this.subscribe = function(feed, sub) {
		if (Array.isArray(feed)) {
			return feed.map( f => this.subscribe(f, sub) );
		}
		this.subscribers[feed] = this.subscribers[feed] || [];
		this.subscribers[feed].push(sub);
		return { feed: feed, index: this.subscribers.length - 1 };
	}
	this.unsubscribe = function(sub) {
		if (Array.isArray(sub)) {
			return sub.forEach( s => this.unsubscribe(s) );
		}
		this.subscribers[sub.feed].splice(sub.index, 1);
	}
	this.getManaged = function() {
		return this.component;
	}
	this.startTransaction = function(name) {
		if (this.txn) {
			throw new Error("Already open transaction");
		}
		this.txn_id = this.nextid++;
		this.txn = {name: name, ops: []};
		this.undostack = this.undostack.slice(0, this.undo_index); 
		this.undostack.push(this.txn);
		++this.undo_index;
		return this.txn_id;
	}
	this.cancelTransaction = function(name, id) {
		if (this.txn && this.txn_id === id && this.txn.name === name) {
			this.txn = null;
		} else {
			throw new Error("no open transaction by that name and id: " + name);
		}
	}
	this.endTransaction = function(id) {
		if (this.txn && this.txn_id === id) {
			let model = this.component;
			model.ops = this.undostack; // TESTT (model.ops || []).concat(this.txn);
			ZProps.set(model.uri, model);
			this.saver(model.uri);
			this.txn = null;
		} else {
			throw new Error("no open transaction by that id: " + id  +", current transaction: " + (this.txn ? this.txn.name : "None"));
		}
	}
	this.destroyPart = function(part_uri) {
		if (!this.txn) {
			throw new Error("No open transaction");
		}
		let { container, node, index } = this.graphapi.getContainerNodeAndIndex(part_uri);
		if (!node) {
			throw new Error("Not found: " + part_uri);
		}
		let op = {op: "destroy", uri: part_uri, data: node, index: index, container: container};
		this.txn.ops.push(op);
		this.__redo(this.txn, [op]);
	}
	// assume part has been cloned from it's reference part already and has a unique uri
	this.createPart = function(part, index, container) {
		if (!this.txn) {
			throw new Error("No open transaction");
		}
		let op = {op: "create", uri: part.uri, data: part, index: index, container: container};
		this.txn.ops.push(op);
		this.__redo(this.txn, [op]);
	}
	this.movePart = function(part, new_index, old_index, container) {
		if (!this.txn) {
			throw new Error("No open transaction");
		}
		let op = {op: "move", uri: part.uri, data: part, new_index: new_index, old_index: old_index, container: container};
		this.txn.ops.push(op);
		this.__redo(this.txn, [op]);
	}
	this.modifyPart = function(part_uri, properties, subpart) {
		if (!this.txn) {
			throw new Error("No open transaction");
		}
		ZLog.debug("AMCTransactions.modify part: " + part_uri);
		let part = this.graphapi.getPart(part_uri);
		if (!part) {
			throw new Error("Not found: " + part_uri);
		}
		if (properties.selected) {
			throw new Error("Do not set this property on model: selected");
		}
		let oldprops = {}, newprops = {};
		for (let key in properties) {
			if (properties.hasOwnProperty(key)) {
				oldprops[key] = subpart ? part[subpart] && part[subpart][key] : part[key];
				newprops[key] = properties[key];
//				part[key] = newprops[key];
			}
		}
		let op = {op: "modify", uri: part_uri, newprops: newprops, oldprops: oldprops, subpart: subpart};
		this.txn.ops.push(op);
		this.__redo(this.txn, [op], true);
	}
	this.update = function(properties, subpart) {
		if (!this.txn) {
			throw new Error("No open transaction");
		}
		ZLog.debug("AMCTransactions.update component: " + this.uri);
		let part = this.component;
		let oldprops = {}, newprops = {};
		for (let key in properties) {
			if (properties.hasOwnProperty(key)) {
				oldprops[key] = subpart ? part[subpart] && part[subpart][key] : part[key];
				newprops[key] = properties[key];
			}
		}
		let op = {op: "update", uri: part.uri, newprops: newprops, oldprops: oldprops, subpart: subpart};
		this.txn.ops.push(op);
		this.__redo(this.txn, [op], true);
	}
	this.undo = function() {
		ZLog.debug("AMCTransactions.undo this.undo_index=" + this.undo_index);
		ZLog.debug("AMCTransactions.undo this.undostack=" + ZUtil.inspect(this.undostack));
		if (this.undo_index > 0) {
			--this.undo_index;
			let txn = this.undostack[this.undo_index];
			if (this.subscriber) {
				this._publish("undo", txn);
			}
			this._undo(txn);
			this.saver(this.uri);
			return true;
		}
		return false;
	}
	this.redo = function() {
		if (this.undo_index < this.undostack.length) {
			let txn = this.undostack[this.undo_index];
			++this.undo_index;
			if (this.subscriber) {
				this._publish("redo", txn);
			}
			this._redo(txn);
			this.saver(this.uri);
			return true;
		}
		return false;
	}
	this.hasUndo = function() {
		return this.undo_index > 0;
	}
	this.hasRedo = function() {
		return this.undo_index < this.undostack.length;
	}
	this.recents = function(count) {
		let recents = [];
		for (let i = this.undostack.length - 1; i >= 0; --i) {
			let txn = this.undostack[i];
			for (let j = txn.ops.length - 1; j >= 0; --j) {
				let op = txn.ops[j];
				if (op.op === "destroy") {
					recents.push(op.data);
				}
			}
			if (recents.length >= count) {
				break;
			}
		}
		return recents;
	}
	this._undo = function(txn) {
		ZLog.debug("_undo");
		for (let i = txn.ops.length - 1; i >= 0; --i) {
			let op = txn.ops[i];
			if (op.op === "destroy") {
				this.graphapi.simpleInsertPart(op.data, op.index, op.container);
				ZProps.set(op.uri, this.graphapi.getPart(op.uri));
			} else if (op.op === "move") {
				this.graphapi.simpleMovePart(op.data, op.old_index, op.new_index, op.container);
			} else if (op.op === "create") {
				this.graphapi.simpleRemovePart(op.uri);
				ZProps.del(op.uri);
			} else if (op.op === "modify" || op.op === "update") {
				ZLog.debug("_undo modify");
				let part = op.op === "update" ? this.component : this.graphapi.getPart(op.uri)
				for (let key in op.oldprops) {
					if (op.oldprops.hasOwnProperty(key)) {
					ZLog.debug("undo key=" + key + ", op.oldprops[key]=" + ZUtil.inspect(op.oldprops[key]));
					ZLog.debug("undo was=" + key + ", " +  ZUtil.inspect(part[key]));
						op.subpart ? part[op.subpart][key] = op.oldprops[key] : part[key] = op.oldprops[key];
						if (part.g && part.g.path) {
							part.g = { left: part.g.left, top: part.g.top };
						}
					}
				}
				ZLog.debug("NOW PART AFTER UNDO =" + ZUtil.inspect(part));
				// Update so listeners can see the changes
				ZProps.set(part.uri, part);
			}
		}
		ZProps.set(this.uri, this.component);
		this._repaint();
	}
	this._repaint = function() {
		this._publish("repaint");
	}
	this._publish = function(feed, ...args) {
		if (this.subscribers[feed]) {
			this.subscribers[feed].forEach( x => { x(feed, ...args) } );
		}
	}
	this._redo = function(txn) {
		let ops = txn.ops;
		this.__redo(txn, ops);
	}
	this.__redo = function(txn, ops, firsttime) {
		for (let i = 0; i < ops.length; ++i) {
			let op = ops[i];
			ZLog.debug("_REDO op=" + op.op);
			if (op.op === "destroy") {
				//op.index = this.graphapi.getPartIndex(op.uri);
				this.graphapi.simpleRemovePart(op.uri, op.container);
				ZProps.del(op.uri);
			} else if (op.op === "move") {
				this.graphapi.simpleMovePart(op.data, op.new_index, op.old_index, op.container);
			} else if (op.op === "create") {
				this.graphapi.simpleInsertPart(op.data, op.index, op.container);
				//op.index = this.graphapi.getPartIndex(op.uri);
				ZProps.set(op.uri, this.graphapi.getPart(op.uri));
			} else if (op.op === "modify" || op.op === "update") {
				let part = op.op === "update" ? this.component : this.graphapi.getPart(op.uri)
				ZLog.debug("op.newprops=" + ZUtil.inspect(op.newprops));
				//if (!firsttime && op.newprops.path) {
					//console.log("replay path: " + op.newprops.path);
				//}
				for (let key in op.newprops) {
					if (op.newprops.hasOwnProperty(key)) {
						if (op.subpart) {
							part[op.subpart] = part[op.subpart] || {};
							part[op.subpart][key] = op.newprops[key];
						} else {
							part[key] = op.newprops[key];
						}
						if (part.g && part.g.path) {
							part.g = { left: part.g.left, top: part.g.top };
						}
					}
				}
				// Update so listeners can see the changes
				ZProps.set(part.uri, part);
			}
		}
		ZLog.debug("redo: now model=" + ZUtil.inspect(this.component));
		ZProps.set(this.uri, this.component);
		this._repaint();
	}
}
export default AMCTransactionsManagerFactory;




// WEBPACK FOOTER //
// ./src/AMCTransactions.js